module.exports = __webpack_public_path__ + "img/沙棘.3a1479b1.jpg";